import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserSessions } from "../store/features/getUserSessions";

const useSessions = (shouldFetch = true) => {
  const [sessions, setSessions] = useState([]);
  const [currentSession, setCurrentSession] = useState(null);
  const [otherSessions, setOtherSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  const sessionId = userData?.response?.sessionId;

  const fetchSessions = useCallback(async () => {
    setLoading(true);
    try {
      const result = await dispatch(getUserSessions());
      const sessionList = result.payload?.sessions || [];
      const current = sessionList.find((session) => session.sessionId === sessionId);
      const others = sessionList.filter((session) => session.sessionId !== sessionId);
      setCurrentSession(current);
      setOtherSessions(others);
      setSessions(sessionList);
    } catch (error) {
      console.error("Error fetching sessions:", error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, sessionId]);

  useEffect(() => {
    if (shouldFetch) {
      fetchSessions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetch, fetchSessions]);

  return {
    sessions,
    currentSession,
    otherSessions,
    loading,
    refetch: fetchSessions,
  };
};

export default useSessions; 